import React, { useState } from "react";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";

const Navbar = () => {
  const [nav, setNav] = useState(false);

  const handleNav = () => {
    setNav(!nav);
  };

  return (
    <div className="flex justify-between items-center h-24 max-w-[1240px] mx-auto px-4 text-white">
      <h1 className="w-full text-2xl md:text-3xl font-bold text-[#00df9a]">
        Landing UI
      </h1>
      <ul className="hidden md:flex">
        <li className="p-4 duration-500 cursor-pointer hover:text-green-600">
          Home
        </li>
        <li className="p-4 duration-500 cursor-pointer hover:text-green-600">
          Company
        </li>
        <li className="p-4 duration-500 cursor-pointer hover:text-green-600">
          Resources
        </li>
        <li className="p-4 duration-500 cursor-pointer hover:text-green-600">
          About
        </li>
        <li className="p-4 duration-500 cursor-pointer hover:text-green-600">
          Contact
        </li>
      </ul>
      <div
        onClick={handleNav}
        className="block md:hidden cursor-pointer hover:scale-125 duration-500"
      >
        {nav ? <AiOutlineClose size={25} /> : <AiOutlineMenu size={25} />}
      </div>
      <ul
        className={
          nav
            ? "fixed left-0 top-0 w-[60%] h-full border-r border-r-gray-900 bg-[#000300] ease-in-out duration-500"
            : "ease-in-out duration-500 fixed left-[-100%]"
        }
      >
        <h1 className="w-full text-2xl font-bold text-[#00df9a] m-4">
          Landing UI
        </h1>
        <li className="p-4 border-b border-gray-600 duration-500 cursor-pointer hover:text-green-600">
          Home
        </li>
        <li className="p-4 border-b border-gray-600 duration-500 cursor-pointer hover:text-green-600">
          Company
        </li>
        <li className="p-4 border-b border-gray-600 duration-500 cursor-pointer hover:text-green-600">
          Resources
        </li>
        <li className="p-4 border-b border-gray-600 duration-500 cursor-pointer hover:text-green-600">
          About
        </li>
        <li className="p-4 duration-500 cursor-pointer hover:text-green-600">
          Contact
        </li>
      </ul>
    </div>
  );
};

export default Navbar;
